import { styled } from "@mui/material";

import DatePicker from "~/components/common/forms/DatePicker";

// Datepicker with only icon button visible
const DatePickerPopup = styled(DatePicker)`
  & {
    visibility: hidden;
  }

  input {
    width: 0;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
  }

  button {
    visibility: visible;
  }
`;
export default DatePickerPopup;
